import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { Currency } from '@40seas/models';
import { z } from 'zod';
import { TransactionMode, TransactionType } from './transaction.entity';

export const WithdrawDtoSchema = z.object({
    amount: z.number().positive(),
    currency: EnumSchema(Currency),
    bankAccount: z.string().regex(/^[0-9a-f]{24}$/i),
    transactions: z.array(z.string()).optional(),
    entitiesIds: z.array(z.string()).optional(),
    type: EnumSchema(TransactionType),
    note: z.string().optional(),
    mode: EnumSchema(TransactionMode).optional(),
});

export class WithdrawDto extends FromSchema(WithdrawDtoSchema) {
    amount: number;
    currency: Currency;
    bankAccount: string;
    transactions?: string[];
    entitiesIds?: string[];
    type: TransactionType;
    note?: string;
    mode?: TransactionMode;
}
